"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Component_1 = __importDefault(require("../Component"));
class SearchComponent extends Component_1.default {
    constructor(className, inputClass, placeholder, inputId) {
        super();
        this.className = className;
        this.inputClass = inputClass;
        this.placeholder = placeholder;
        this.inputId = inputId;
    }
    getTemplate() {
        return `
      <div class="${this.className}">
        <input class="${this.inputClass}" id="${this.inputId}" type="search" placeholder="${this.placeholder}">
      </div>
    `;
    }
    addOnChange(callback) {
        const input = document.getElementById(this.inputId);
        if (!(input instanceof HTMLInputElement)) {
            throw new Error(`Element with id "${this.inputId}" is not an instanceof HTMLInputElement`);
        }
        input.addEventListener('input', callback);
    }
}
exports.default = SearchComponent;
